module.exports = __webpack_public_path__ + "static/media/logo.8482ca9c.png";